import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const theme: ThemeApp['appComponents']['sectionCard'] = {
  boxShadow: themeUi.core.shadow.shadow4
};

export default theme;
